import { useState } from "react"
import { Button } from "./ui/Button"
import { Linkedin, Github } from 'lucide-react'
import { useTheme } from "./ThemeContext"
import Typewriter from "./Typewriter"

export default function Hero() {
  const { theme } = useTheme()
  const [isImageHovered, setIsImageHovered] = useState(false)

  const typewriterWords = ["Software Engineer", "Software Developer", "Full-stack Developer"]

  return (
    <section
      id="home"
      className="min-h-screen bg-gradient-to-r from-blue-500 to-purple-600 dark:from-blue-900 dark:to-purple-900 flex items-center justify-center px-4 transition-all duration-300"
    >
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-2xl overflow-hidden max-w-4xl w-full transition-colors duration-300">
        <div className="grid grid-cols-1 md:grid-cols-2">
          {/* Left side - Purple section with image and social icons */}
          <div className="bg-gradient-to-br from-blue-500 to-purple-600 dark:bg-gray-900 p-8 flex flex-col items-center transition-colors duration-300">
            <div className="flex-1 flex items-center justify-center mb-6">
              <div
                className="relative cursor-pointer transition-all duration-300"
                onMouseEnter={() => setIsImageHovered(true)}
                onMouseLeave={() => setIsImageHovered(false)}
              >
                {/* Color Image */}
                <img
                  src="/images/harsh-vardhan-color.jpg"
                  alt="Harsh Vardhan - Color"
                  width={250}
                  height={250}
                  className={`rounded-lg shadow-lg transition-all duration-500 object-cover ${
                    isImageHovered ? "opacity-0" : "opacity-100"
                  }`}
                />
                {/* Black and White Image */}
                <img
                  src="/images/harsh-vardhan-bw.jpg"
                  alt="Harsh Vardhan - Black and White"
                  width={250}
                  height={250}
                  className={`rounded-lg shadow-lg absolute top-0 left-0 object-cover transition-all duration-500 ${
                    isImageHovered ? "opacity-100" : "opacity-0"
                  }`}
                />
              </div>
            </div>

            {/* Social icons bar - matches image width */}
            <div className="bg-yellow-400 rounded-lg p-4 flex justify-center space-x-6 w-[250px]">
              <a href="https://www.linkedin.com/in/harsh-vardhan-singh-26aba4227/">
              <Linkedin className="h-8 w-8 text-blue-600 hover:text-blue-800 cursor-pointer transition-colors" />
              </a>
              <a href="https://github.com/harsh-vardhan1/">
              <Github className="h-8 w-8 text-gray-800 hover:text-black cursor-pointer transition-colors" />
              </a>
            </div>
          </div>

          {/* Right side - Text content */}
          <div
            className={`p-8 flex flex-col justify-center space-y-6 transition-colors duration-300 ${
              theme === "dark" ? "bg-gray-800" : "bg-white"
            }`}
          >
            <div>
              <h1
                className={`text-4xl lg:text-5xl font-bold leading-tight transition-colors duration-300 ${
                  theme === "dark" ? "text-yellow-400" : "text-gray-800"
                }`}
              >
                Hello,
                <br />
                I'm Harsh
                <br />
                Vardhan
              </h1>
              <div className="mt-4">
                <Typewriter
                  words={typewriterWords}
                  className={`text-xl transition-colors duration-300 ${
                    theme === "dark" ? "text-gray-300" : "text-gray-600"
                  }`}
                />
              </div>
            </div>

            <Button
            onClick={() => window.open("https://drive.google.com/file/d/1_CusLMGAsRWQ96ZyT4na4yi7kzdTuEO4/view?usp=sharing", "_blank")}
              className={`px-8 py-3 rounded-full text-lg font-semibold w-fit transition-all duration-300 ${
                theme === "dark"
                  ? "bg-yellow-500 hover:bg-yellow-600 text-black"
                  : "bg-blue-600 hover:bg-blue-700 text-white"
              }`}
            >
              RESUME
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}